import { Link } from 'react-router-dom';

export default function About() {
  const features = [
    { icon: 'ri-user-star-line', text: 'Exclusivo para Atuantes' },
    { icon: 'ri-flashlight-line', text: 'Alta Performance' },
    { icon: 'ri-brain-line', text: 'Energia & Consciência' },
    { icon: 'ri-trophy-line', text: 'Resultados Reais' }
  ];

  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block border-2 border-[#262364] text-[#262364] px-6 py-2 rounded-full text-xs font-bold uppercase tracking-wider mb-6">
            Sobre
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-black text-[#262364] mb-8">
            O Que É a AAPEQ
          </h2>
          
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            AAPEQ é uma escola de aprimoramento avançada para quem já atua — artistas, atletas, diretores, professores, treinadores e estudantes.
          </p>
          
          <p className="text-lg text-gray-700 leading-relaxed">
            Aqui, ninguém começa do zero. O aluno refina técnica, energia, presença, consciência e potência emocional, integrando arte, energia, telepatia aplicada e alta performance mental.
          </p>

          <div className="mt-8">
            <Link
              to="/o-treinador"
              className="inline-flex items-center gap-2 text-sm font-medium text-[#F05954] hover:text-[#262364] transition-colors cursor-pointer"
            >
              Saiba mais sobre o Treinador
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-20">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col items-center text-center group">
              <div className="w-20 h-20 rounded-full border-3 border-[#F05954] flex items-center justify-center mb-4 transition-all group-hover:bg-[#F05954] group-hover:scale-110">
                <i className={`${feature.icon} text-3xl text-[#262364] group-hover:text-white transition-colors`}></i>
              </div>
              <p className="text-sm font-bold text-[#262364]">{feature.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}